
import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { Card, CardContent } from "@/components/ui/card";
import { useLoanCalculator } from "@/hooks/useLoanCalculator";
import { Link } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";

export const WeddingLoanCalculator = () => {
  const [loanAmount, setLoanAmount] = useState(15000);
  const [loanTerm, setLoanTerm] = useState(5);
  const { trackEvent, trackNavigationToApplication } = useAnalytics();
  
  const { 
    monthlyPayment, 
    totalPaid, 
    interestAndFees,
    interestRate
  } = useLoanCalculator(loanAmount, loanTerm, "haalaina");

  // Create URL with parameters for the loan application page
  const applicationUrl = `/kilpailuta?amount=${loanAmount}&term=${loanTerm}&type=haalaina`;

  const handleLinkClick = () => {
    // Track calculator usage event
    trackEvent('wedding_loan_calculator_used', {
      loanAmount,
      loanTerm,
      interestRate
    });
    
    // Track navigation to application with source information
    trackNavigationToApplication('wedding_loan_page', {
      loanType: 'haalaina',
      loanAmount,
      loanTerm,
      interestRate
    });
  };

  return (
    <Card className="shadow-md border-pink-100">
      <CardContent className="p-6">
        <h2 className="text-2xl font-bold text-pink-700 mb-6">Laske häälainasi</h2>
        
        <div className="mb-8">
          <div className="flex justify-between items-center mb-2">
            <label className="font-medium text-gray-700">Lainan määrä: {loanAmount} €</label>
          </div>
          <Slider
            value={[loanAmount]}
            min={5000}
            max={50000}
            step={1000}
            onValueChange={(value) => setLoanAmount(value[0])}
            className="mb-6"
          />

          <div className="flex justify-between items-center mb-2">
            <label className="font-medium text-gray-700">Laina-aika: {loanTerm} vuotta</label>
          </div>
          <Slider
            value={[loanTerm]}
            min={1}
            max={15}
            step={1}
            onValueChange={(value) => setLoanTerm(value[0])}
          />
        </div>
        
        <div className="bg-pink-50 p-4 rounded-lg mb-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-600">Kuukausierä:</p>
              <p className="text-xl font-bold text-pink-700">{monthlyPayment} €/kk</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Korko:</p>
              <p className="text-xl font-bold text-pink-700">{interestRate} %</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Kokonaiskustannus:</p>
              <p className="text-xl font-bold text-pink-700">{totalPaid} €</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Korkokulut:</p>
              <p className="text-xl font-bold text-pink-700">{interestAndFees} €</p>
            </div>
          </div>
        </div>
        
        <Link 
          to={applicationUrl}
          onClick={handleLinkClick}
          className="bg-pink-600 hover:bg-pink-700 text-white w-full py-3 rounded-md font-medium flex justify-center items-center transition-colors"
        >
          Hae häälainaa
        </Link>
        
        <p className="text-xs text-gray-500 mt-4">
          Esimerkki: 15 000 € laina 5 vuoden maksuajalla. Nimelliskorko 5.9 %, 
          todellinen vuosikorko 6.1 %. Kokonaiskustannukset 18 750 €.
        </p>
      </CardContent>
    </Card>
  );
};
